export enum SDPDirectionEnum {
  CONS = 'CONS',
  PROD = 'PROD',
  COMB = 'COMB',
}
